/* eslint-disable no-underscore-dangle */
import React, { useEffect, useMemo } from 'react';
import { useIntl } from 'umi';
import { inject, observer } from 'mobx-react';
import s from './index.less';
import POPOLOG from '@/assets/POPO.png';
import GUEST_AVATAR from '@/assets/guest.png';
import User from '@/models/user';
import Meeting from '@/models/meeting';
import { Icon } from '@/components';
import { clearSessionStorage, getQueryString } from '@/utils/common';
import { get } from 'lodash-es';
import { Dropdown } from 'antd';
interface LoginHeaderProps {
  meeting?: Meeting;
  user?: User;
}
export enum LOGIN_TYPE {
  Oscar = 'Oscar',
  NEOpenID = 'NEOpenId',
  GUEST = 'Guest',
}
const LoginHeader: React.FC<LoginHeaderProps> = inject(({ store }) => {
  return {
    meeting: store.meeting,
    user: store.user,
  };
})(
  observer((props) => {
    const { user, meeting } = props;
    const avatar = getQueryString('guest') == '1' ? GUEST_AVATAR : user?.avatarUrl || GUEST_AVATAR;
    const { formatMessage } = useIntl();
    const showLogout = useMemo(() => {
      return !(
        get(meeting, 'info.supportedAuthTypes.length') === 1 &&
        get(meeting, 'info.supportedAuthTypes.0') === LOGIN_TYPE.GUEST
      );
    }, [meeting?.info?.supportedAuthTypes]);

    const handleBack = async () => {
      await user?.logout(meeting?.info?.meetingId).catch((e) => console.error(e));
      clearSessionStorage();
      const search = new URLSearchParams(location.search);

      if (search.has(LOGIN_TYPE.GUEST)) {
        search.delete(LOGIN_TYPE.GUEST);
      }
      if (search.has(LOGIN_TYPE.Oscar)) {
        search.delete(LOGIN_TYPE.Oscar);
      }
      if (search.has(LOGIN_TYPE.NEOpenID)) {
        search.delete(LOGIN_TYPE.NEOpenID);
      }
      if (search.has('needOpenAuth')) {
        search.delete('needOpenAuth');
      }
      let nextSearch = '';
      for (const [key, value] of search.entries()) {
        nextSearch += `${key}=${value}&`;
      }
      nextSearch = nextSearch.slice(0, -1);

      location.href = `/meet/${meeting?.info?.meetingId}/meeting?${nextSearch}`;
    };

    const items = [
      {
        key: '1',
        label: (
          <span className={s.btn} onClick={handleBack}>
            <span className={s.operation}>{formatMessage({ id: 'switchAccounts' })}</span>
            <Icon name="icon-arrow_line_right_1" mode="symbol" className={s.icon} size={16}></Icon>
          </span>
        ),
      },
    ];

    return (
      <div className={s.container}>
        <img src={POPOLOG} className={s.left} />
        {showLogout ? (
          <Dropdown
            menu={{ items }}
            arrow={false}
            placement="bottomRight"
            overlayClassName={s.dropdown}
          >
            <span className={s.right}>
              <div className={s.name}>{user?.name || formatMessage({ id: 'guest' })}</div>
              <img src={avatar} className={s.avatar} />
            </span>
          </Dropdown>
        ) : (
          <div className={s.right}>
            <div className={s.name}>{user?.name || formatMessage({ id: 'guest' })}</div>
            <img src={avatar} className={s.avatar} />
          </div>
        )}
      </div>
    );
  })
);
export default LoginHeader;
